import { FC } from 'react';

import { useTitle } from '../hooks/useTitle';

import Signin from 'src/components/templates/Signin/Signin';

const SigninPage: FC = () => {
  useTitle('GU | 로그인');
  return <Signin />;
};

export default SigninPage;
